module.exports = __webpack_public_path__ + "483d253e38021e66885b8ee8d55fc470.pdf";